module.exports = __webpack_public_path__ + "img/collar_edges_length.6cd5ef22.png";